import { render } from "./SelectButton.vue?vue&type=template&id=654084ba&scoped=true"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import "./SelectButton.vue?vue&type=style&index=0&id=654084ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-654084ba"

export default script